import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const PayStatementsPage = leadLazyLoad(
  () => import('./PayStatementsPage'),
  module => module.PayStatementsPage,
  { fallback: null, type: LeadPageType.TIME_AND_PAY },
);
